import { apiFetch } from "@/lib/api-client";
export function pickLatestPreAssessment(items) {
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return undefined;
    }
    return [...items].sort((a, b) => {
        var _a, _b, _c, _d;
        const aTime = Date.parse((_b = (_a = a.updated_at) !== null && _a !== void 0 ? _a : a.created_at) !== null && _b !== void 0 ? _b : "") ||
            Number.NEGATIVE_INFINITY;
        const bTime = Date.parse((_d = (_c = b.updated_at) !== null && _c !== void 0 ? _c : b.created_at) !== null && _d !== void 0 ? _d : "") ||
            Number.NEGATIVE_INFINITY;
        return bTime - aTime;
    })[0];
}
/** Latest completed assignment with answers; falls back to most recent assignment. */
export function pickLatestCompletedPreAssessment(items) {
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return undefined;
    }
    const completed = items.filter((item) => item.status === "completed" && item.answered_pre_assessment != null);
    return pickLatestPreAssessment(completed.length > 0 ? completed : items);
}
export function getLatestPreAssessmentStatus(items) {
    const latest = pickLatestPreAssessment(items);
    if ((latest === null || latest === void 0 ? void 0 : latest.status) === "completed" || (latest === null || latest === void 0 ? void 0 : latest.status) === "sent") {
        return latest.status;
    }
    return null;
}
/** Reads latest pre-assessment status from a patient list/detail API payload when present. */
export function readLatestPreAssessmentStatusFromApiPatient(patient) {
    if (!patient || typeof patient !== "object") {
        return null;
    }
    const record = patient;
    const direct = record.latest_pre_assessment_status;
    if (direct === "completed" || direct === "sent") {
        return direct;
    }
    const nested = record.latest_pre_assessment;
    if (nested && typeof nested === "object") {
        const status = nested.status;
        if (status === "completed" || status === "sent") {
            return status;
        }
    }
    return null;
}
export function patientPreAssessmentsQueryKey(patientId, token) {
    return ["patient-preassessments", patientId, token];
}
export async function fetchPatientPreAssessments(patientId, token) {
    var _a;
    const res = await apiFetch(`/api/patients/${patientId}/preassessments`, {
        token,
        cache: "no-store",
    });
    if (!res.ok) {
        return [];
    }
    const data = (await res.json());
    return (_a = data.pre_assessments) !== null && _a !== void 0 ? _a : [];
}
export async function fetchLatestPreAssessmentStatus(patientId, token) {
    try {
        const items = await fetchPatientPreAssessments(patientId, token);
        return getLatestPreAssessmentStatus(items);
    }
    catch (_a) {
        return null;
    }
}
